// get-departments-city.js

// 🔹 Obtener todos los departamentos de Colombia
export const getDepartments = async () => {
  try {
    const response = await fetch("https://api-colombia.com/api/v1/Department");

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();

    // Retornamos un arreglo con { id, name } asegurando que id sea numérico
    return data.map((dep) => ({
      id: dep.id || dep.name, // fallback si no hay id
      name: dep.name,
    }));
  } catch (error) {
    console.error("Error fetching departments:", error);
    return [];
  }
};

// 🔹 Obtener las ciudades según el ID del departamento
export const getCitiesByDepartment = async (departmentId) => {
  if (!departmentId) return [];

  try {
    // Si departmentId es texto, busca el departamento por nombre para obtener su ID
    const isNumeric = !isNaN(departmentId);
    let depId = departmentId;

    if (!isNumeric) {
      const departments = await getDepartments();
      const match = departments.find(
        (dep) => dep.name.toLowerCase() === departmentId.toLowerCase()
      );
      depId = match ? match.id : null;
    }

    if (!depId) {
      console.warn(`⚠️ No se encontró el ID para el departamento: ${departmentId}`);
      return [];
    }

    const response = await fetch(
      `https://api-colombia.com/api/v1/Department/${depId}/cities`
    );

    if (!response.ok) {
      console.warn(
        `⚠️ La API devolvió un error ${response.status} al consultar las ciudades de ${departmentId}`
      );
      return [];
    }

    const text = await response.text();
    if (!text) return [];

    const data = JSON.parse(text);
    return Array.isArray(data) ? data.map((city) => city.name) : [];
  } catch (error) {
    console.error(`Error fetching cities for department ${departmentId}:`, error);
    return [];
  }
};
